<div *ngIf="exportButtonList" fxLaout="column">
  <div *ngIf="!data.input['transmission']">
    <mat-form-field class="m-b-20 w-p-100" appearance="outline">
      <mat-label>Select an option</mat-label>
      <mat-select [value]="selectedExportOptions" (selectionChange)="onSelectionChange($event)">
        <mat-option *ngFor="let option of dropDownOptions" [value]="option">{{option.MetaData['Title']}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <particle-multiple-button-editor class="m-b-20" [buttonsList]="exportButtonList"
                                   (buttonClick)="onExport($event)"> </particle-multiple-button-editor>
  <div *ngIf="selectedExportOptions.Footer && selectedExportOptions.Footer !=='' && hasMergedItem" class="blue-box-container">
    <strong>Please note: </strong> <span></span> <span>{{selectedExportOptions.Footer}} <b>{{XmlMergeCountrySupport}}</b>.</span>
  </div>
</div>
